import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, Download } from "lucide-react";
import { api } from "@/lib/api";
import { useTranslations } from "@/hooks/use-translations";
import { useAuth } from "@/hooks/use-auth";
import { FilePreview, formatFileSize } from "@/components/files/file-preview";
import { Button } from "@/components/ui/button";

export function FileViewerPage() {
	const { user } = useAuth();
	const { fileId } = useParams();
	const t = useTranslations("fileReports");
	const { data: file, isLoading, isError, refetch } = useQuery({
		queryKey: ["file", user?.id, fileId], queryFn: () => api.getFile(fileId!), enabled: !!fileId && !!user?.id,
	});
	return <div className="min-h-screen p-6 bg-bg-canvas text-text-primary"><div className="max-w-5xl mx-auto space-y-6">
		<Link to="/media" className="inline-flex items-center gap-2 text-text-secondary hover:text-text-primary"><ArrowLeft size={18} />{t("library")}</Link>
		{isLoading && <p>{t("loading")}</p>}
		{isError && <div className="space-y-3"><p className="text-danger">{t("unavailable")}</p>
			<Button variant="secondary" onClick={() => refetch()}>{t("retry")}</Button></div>}
		{file && <>
			<div className="flex flex-wrap justify-between gap-4">
				<div className="min-w-0"><h1 className="text-xl font-semibold break-words">{file.title ?? t("untitled")}</h1>
					<p className="text-sm text-text-tertiary mt-2">{file.mimeType} · {formatFileSize(file.sizeBytes)}</p>
					{file.report && <Link to={`/analyzer?audit=${file.report.analysisId}`} className="text-sm text-text-link underline underline-offset-2">{file.report.domain} · {t("openAudit")}</Link>}
				</div>
				<Button asChild className="self-start"><a href={api.fileDownloadUrl(file.id)}><Download size={16} />{t("download")}</a></Button>
			</div>
			{file.report?.deliveryState !== "ready" && file.report && <p className="text-warning text-sm">{t("setIncomplete")}</p>}
			<div className="rounded-2xl border border-border-subtle bg-bg-surface p-6 md:p-8"><FilePreview file={file} /></div>
		</>}
	</div></div>;
}
